import "./Login.css";
import { useState } from "react";
import { API_BASE_URL } from "./config";
import axios from "axios";
import Navbar from "./components/Navbar";


function Login() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false); // Track success state
  const [error, setError] = useState("");

  async function submitForm() {
    // Reset messages
    setError("");

    if (!email) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/send_login_link`, {
        email,
      });

      if (response.status === 200) {
        setSuccess(true); // Set success state to true
      }
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 200 range
        if (error.response.status === 400) {
          setError("Email is required.");
        } else if (error.response.status === 404) {
          setError("Invalid Email or unable to send.");
        } else {
          setError("An unexpected error occurred.");
        }
      } else {
        // Network error or other issues
        setError("Unable to reach the server. Please try again later.");
      }
    } finally {
      setSuccess(true); // Set success state to true even if there's an error
    }
  }

  function resetForm() {
    setEmail("");
    setSuccess(false);
    setError("");
  }

  // Add a keyDown event listener to handle the Enter key press
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      submitForm();
    }
  }

  return (
    <>
    <Navbar />
      <div className="login-main">
        <div className="login-box">
          {success ? (
            <>
              <p>
                Thank you. If you have access to this system you will receive an
                email with a link to login.
              </p>
              <button className="eagle-point-btn" onClick={resetForm}>
                Try Again
              </button>
            </>
          ) : (
            <>
              {error ? (
                <p className="error-message">{error}</p>
              ) : (
                <p>Please enter your email address in the field below</p>
              )}

              <div className="input-combo">
                <label>Email</label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="text-input"
                />
              </div>
              <button className="eagle-point-btn" onClick={submitForm}>
                Send Login Link
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Login;
